export default __webpack_public_path__ + "static/media/Roboto-Regular.5e1aec00.woff";